<template>
  <div class="hello">
    <div class="texto">
    <h1>Headways Media</h1>
    <p>
      Fully focused on profitability, here we create and implement innovative digital strategies for our clients.
      <a href="mailto:info@headways.com.mx" rel="noopener">Contact</a>.
    </p>
    <h3>Let´s make Headways</h3>
    <ul>
      <li><a href="https://headways.digital/" target="_blank" rel="noopener">Headways Digital</a></li>
      <li><a href="https://headways.com.mx/" target="_blank" rel="noopener">Headways Méxio</a></li>
    </ul>
    </div>

      <div id="fullwidth-video">
      <div class="over"></div>
      <div class="fullwidth-video-bg">
      <video playsinline="" muted="" onplaying="this.controls=false" autoplay loop>
      <source src="../assets/inicio.mp4" type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'>
      <source src="../assets/inicio.mp4" type='video/webm; codecs="vp8, vorbis"'>
      <source src="../assets/inicio.mp4" type='video/ogg; codecs="theora, vorbis"'>
      </video>
      </div>
      </div>
   
  </div>
 

</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #f7882d;
}
		#fullwidth-video{height: 50vw; min-height:50vh; position: fixed;}
#fullwidth-video .fullwidth-video-bg {
position: fixed; z-index: 1; top: 0px; left: 0px; bottom:
0px; right: 0px; overflow: hidden;
background-size: cover; background-color: transparent; background-repeat: no-repeat;
background-position: 0% 50%;
}
.sldtext {z-index: 2;}
#fullwidth-video video {
margin: auto; position: fixed; z-index: 1; top: 50%; left: 0%;
transform: translate(0%, -50%); visibility: visible;
opacity: 1; width: 100%; height: 100%; object-fit: cover;
}
.over{
    position: fixed;
    width: 100%;
    height: 100vh;
    background: #000000d4;
    z-index: 2;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
}
.texto{
	position: absolute;
    z-index: 3;
    width: 100%;
    text-align: center;
    color:#fff;
}
/** For Edge**/
@supports (-ms-ime-align:auto){ #fullwidth-video video
{ object-fit:none; margin:none;position:inherit;z-index:1;
top:50%;left:0%;transform:translate(0%, -50%);height:auto;width:100%; } }
</style>
